// RITM1216061
import React, { Component } from "react";

import Data16 from "@carbon/icons-react/lib/data--1/16";
import PageBreadCrumb from "./../../helpers/PageBreadCrumb";
import SimpleReactValidator from "simple-react-validator";
import moment from "moment";
import { AppContext } from "./../../helpers/context/AppContext";
import { ComboBox } from "../../helpers/ComboBox";
import { ConfirmAlertCustom } from "./../../helpers/ConfirmAlertCustom";
import { Download16, Add16, Edit16, Delete16 } from "@carbon/icons-react";
import { Online } from "./../common/OnLineOffLine";
import { RenderDataTableCell, NoRecordsPlaceholder } from "../../helpers/jsonschemaform/DataTableExtention";
import {
	Search,
	TableToolbar,
	Loading,
	Button,
	Form,
	FormGroup,
	FormLabel,
	TextInput,
	DataTable,
	TableContainer,
	DataTableSkeleton,
	Pagination,
	Table,
	TableHead,
	TableRow,
	TableHeader,
	TableBody,
	TableCell,
	ComposedModal,
	ModalHeader,
	ModalBody,
	DropdownSkeleton,
	MultiSelect,
	TextArea,
} from "carbon-components-react";
import { api, dynamic } from "./../../helpers/api/api";
import { entitiesLabels, apioperation, getError, getSuccess, DateFormat } from "../../helpers/Constants";
import { showNotification } from "./../../helpers/notification/BaseNotification";
import { v4 as uuid } from "uuid";
import _sortBy from 'lodash/sortBy';
import DateTimePicker from '../../helpers/DateTimePicker';

const modelProp = {
	id: undefined,
	hcaLevelNames: null,
	validSince: null,
	validUntil: null,
	ranking: null,
	idDivision: null,
	recipientType: null,
	distributionListType:null,
	emailAddress: null,
	selectedHca: [],
	idInvestigation: null
};

const recipientType = ["To", "Cc", "Bcc"];
const hcalevel = ['Level 0 - Negligible / No conseq.', 'Level 1 - Minor Conseq.', 'Level 2 - Moderate Conseq.', 'Level 3 - Severe Conseq.', 'Level 4 - Fatality', 'Level 5 - Fatalities'] //Change requested by Alessandro on 10/04/2026
const distributionListType =["Reports", "Incidents CAR/CA","Incidents","Audit Program","Audit Report"]

export class DistributionListHCAlevel extends Component {
	constructor(props) {
		super(props);
		this.validator = new SimpleReactValidator();
		this.state = {
			// Paging
			currentPage: 1,
			pageSize: 10,
			rowCount: 0,

			// Loaders
			isExportLoading: false,
			isLoadingEntity: false,

			// Edit modal
			isUpdateMode: false,
			isEditModalOpen: false,
			divisions: [],

			// Insert / edit model
			model: { ...modelProp },

			// Delete
			idToDelete: null,
			isDeleting: false,
			isDeleteModalOpen: false,

			// Used for update
			loading: false,
			reportDistributionListPaged: [],
			reportDistributionListAll: [],
		};
	}

	componentDidMount() {
		this.setState({ loading: true });
		this.getAllDivisions();
		// Main list
		this.getPagedFilteredDistributionListIncident();
		this.setState({ loading: false });
	}

	getPagedFilteredDistributionListIncident = (param) => {
		this.setState({ isLoadingEntity: true });

		const filter = {
			page: param && param.page ? param.page : this.state.currentPage,
			pageSize: param && param.pageSize ? param.pageSize : this.state.pageSize,
		};

		const data = { params: { ...filter } };
		api
			.getWithParam('/distributionlist/distributionlistall', data)
			.then((res) => {
				if (res.status === 200) {
					const { data } = res;
					this.setState({
						currentPage: data.currentPage,
						pageSize: data.pageSize,
						rowCount: data.rowCount,
						reportDistributionListPaged: data.itemList,
					});
				} else {
					showNotification.error();
				}
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.DISTRIBUTIONLIST, apioperation.GET));
			})
			.finally(() => {
				this.setState({ isLoadingEntity: false });
			});
	};

	
	// Modals
	openAddNewModal = () => {
		this.setState({
			isUpdateMode: false,
			isEditModalOpen: true,
		});
	};

	closeEditModal = () => {
		if (!this.validator.allValid()) {
			this.getPagedFilteredDistributionListIncident();
		}
		this.setState({
			model: { ...modelProp },
			isEditModalOpen: false,
		});
		this.validator.hideMessages();
	};

	// Excel export
	downloadFile() {
		if (this.state.isExportLoading) return;

		this.setState({ isExportLoading: true });

		api.getWithParam("/distributionlist/downloadexcel", { responseType: "arraybuffer" })
			.then((response) => {
				var data = new Blob([response.data], {
					type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
				});
				var csvURL = window.URL.createObjectURL(data);
				var tempLink = document.createElement("a");
				tempLink.href = csvURL;

				var fileName = "Export_" + "DistributionListIncident_" + moment().format("YYYYMMDDHHmmSS") + ".xlsx";
				tempLink.setAttribute("download", fileName);

				document.body.appendChild(tempLink);
				tempLink.click();
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, "Download File", apioperation.GET));
			})
			.finally(() => {
				this.setState({ isExportLoading: false });
			});
	}

	handleOnChange = (inputName, selectedItem, objName) => {
		const inputValue = selectedItem ? selectedItem : null;
		const stateCopy = { ...this.state };

		stateCopy[objName][inputName] = inputValue;
		this.setState(stateCopy);
	};

	handleChangeModel = (el) => {
		let inputName = el.target.name;
		let inputValue = el.target.value;
		this.updateState(inputName, inputValue, 'model');
	};
	returnHCALevelName = (listofHcaElement, selectedHcalist) => {
        return selectedHcalist.includes(listofHcaElement);
    };
	onChangehcaLevelNames = (inputName, selectedItems, objName) => {
		const element = selectedItems?.map((elem) => elem).join(', ');
		this.updateState(inputName, element, objName);
	};

	// Edit modal insertion
	insertDistributionList = () => {
		if (this.validator.allValid()) {
			this.setState({
				isSubmitted: true,
			});

			const formData = this.state?.model;
			if (!this.state.isUpdateMode) {
				formData.id = uuid();
			}

			const method = this.state.isUpdateMode ? api.put('/distributionList/edit', formData) : api.post('/distributionList/create-distributionList', formData);

			method
				.then(async (response) => {
					if (response.status === 200) {
						showNotification.success(`${entitiesLabels.SUCCESS}`, "Successfully saved");
						this.setState(
							{
								isLoading: false,
							},
							this.closeEditModal
						);
					} else {
						showNotification.error(`${entitiesLabels.ERROR}`, getError("Unsuccessfully saved", entitiesLabels.DISTRIBUTIONLIST, apioperation.POST));
					}
				})
				.catch((error) => {
					showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.DISTRIBUTIONLIST, apioperation.POST));
				})
				.finally(() => {
					this.setState(
						{
							isLoading: false,
						},
						() => {
							this.getPagedFilteredDistributionListIncident();
							this.forceUpdate();
						}
					);
				});
		} else {
			this.validator.showMessages();
			showNotification.warning(`${entitiesLabels.WARNING}`, `${entitiesLabels.DISTRIBUTIONLIST} required fields are missing  `);
			this.forceUpdate();
		}
	};

	// Edit modal update
	getDistributionListForEdit = (id) => {
		this.setState({
			isUpdateMode: true,
			isEditModalOpen: true,
		});

		let incidentToChange = this.state.reportDistributionListPaged.find((x) => x.id == id);
		this.setState({
			model: incidentToChange,
		});
	};

	updateState = (inputName, inputValue, objName) => {
		const statusCopy = { ...this.state.model };
		if (objName && objName != "model") statusCopy[objName][inputName] = inputValue;
		else statusCopy[inputName] = inputValue;

		this.setState({ model: statusCopy });
	};

	// Delete modal
	confirmDelete = (id) => {
		this.setState({
			idToDelete: id,
			isDeleteModalOpen: true,
			isDeleting: false,
		});
	};

	deleteItem = () => {
		let id = this.state.idToDelete;
		this.setState({ isDeleting: true });
		const formData = this.state.reportDistributionListPaged.find((x) => x.id === id);

		api
			.deleteData('/distributionlist/delete/', formData)
			.then((response) => {
				if (response.status === 200) {
					this.setState({
						idToDelete: null,
						isDeleteModalOpen: false,
					});
					this.onCloseConfirm();
					this.getPagedFilteredDistributionListIncident();
					showNotification.success(`${entitiesLabels.SUCCESS}`, getSuccess(entitiesLabels.DISTRIBUTIONLIST, apioperation.DELETE));
				} else {
					showNotification.error();
				}
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.DISTRIBUTIONLIST, apioperation.DELETE));
			})
			.finally(() => {
				this.setState({ isDeleting: false });
			});
	};

	onCloseConfirm = () => {
		this.setState({ isDeleteModalOpen: false });
	};

	// Render methods

	getAllDivisions = () => {
		api.getAll("/me/divisions").then((res) => {
			this.setState({ divisions: res.data });
		});
	};
	handleChangeModelDivision = (inputName, selectedItem, objName) => {
		const inputValue = selectedItem ? selectedItem.id : null;
		const stateCopy = { ...this.state };
		stateCopy[objName][inputName] = inputValue;

		this.setState(stateCopy);
	};
	renderDetailsForm() {
		const modalHeader = {
			title: (this.state.isUpdateMode ? "Edit " : "Add new ") + "Incident Distribution",
			iconDescription: "Close",
			buttonOnClick: () => this.closeEditModal(),
		};

		const validations = {
			emailAddress: this.validator.message("Email Address", this.state.model.emailAddress, "required"),
			recipientType: this.validator.message('Receient Type', this.state.model.recipientType, 'required'),
			division: this.validator.message("businessLine", this.state.model.idDivision, "required"),
			validSince: this.validator.message('Valid Since', this.state.model.validSince, 'required'),
			validUntil: this.validator.message('Valid Until', this.state.model.validUntil, 'required'),
			endAfterStart: this.validator.message(
				'endAfterStart',
				this.state.model.validUntil == null ||
				this.state.model.validSince == null ||
				moment(this.state.model.validUntil).isSameOrAfter(
					moment(this.state.model.validSince),
					'day'
				),
				'accepted'
			),
			distributionListType: this.validator.message('DistributionListType', this.state.model.distributionListType, 'required'),
			hcaLevelNames: this.validator.message('hcaLevelNames', this.state.model.distributionListType == 'Incidents' && this.state.model.hcaLevelNames, 'required'),
		};

		return (
			<ComposedModal className="light-modal" open={this.state.isEditModalOpen} danger="false" onClose={() => this.closeEditModal()}>
				<ModalHeader className="margin-modal" {...modalHeader} />
				<ModalBody className="margin-modal margin-modal-content">
					<Form className="bx--grid--full-width">
						<div className="bx--row">
							<FormGroup legendText="" className="bx--col-md-12 bx--col-lg-12">
								<FormLabel>Email Address*</FormLabel>
								<TextInput
									id="modelemail"
									name="emailAddress"
									placeholder="Input Email Address"
									required
									value={this.state.model.emailAddress ? this.state.model.emailAddress : ''}
									onChange={this.handleChangeModel}
									invalid={validations.emailAddress != null}
									type="text"
									labelText=""
									className="bx--text-input  bx--text-input--light"
									disabled={false}
								/>
								{validations.emailAddress}
							</FormGroup>
							<FormLabel>Business Line*</FormLabel>
							<FormGroup legendText="" className="bx--col-md-12 bx--col-lg-12">
								<ComboBox
									id="idDivision"
									placeholder=""
									name="idDivision"
									alt="model"
									onChange={this.handleChangeModelDivision}
									itemToString={(item) => (item && item.name) || ""}
									initialSelectedItem={this.state.model.division || []}
									items={this.state.divisions}
									direction="bottom"
									invalid={validations.division != null}
								/>
								{validations.division}
							</FormGroup>
							<FormGroup legendText="" className="bx--col-md-12 bx--col-lg-12">
								<FormLabel>Type*</FormLabel>								
								<ComboBox
									key={"modelDistributionListType" + this.state.model.distributionListType}
									id="modelDistributionListType"
									placeholder=""
									name="distributionListType"
									alt="model"
									onChange={this.handleOnChange}
									itemToString={(item) => item || ""}
									initialSelectedItem={this.state.model.distributionListType || []}
									items={distributionListType}
									direction="bottom"
									disabled={false}
									invalid={validations.distributionListType != null}
								/>
								 {validations.distributionListType}
							</FormGroup>
							<FormGroup legendText="" className="bx--col-md-12 bx--col-lg-12">
								<FormLabel>Recipient Type*</FormLabel>
								<ComboBox
									key={"modelrecipientType" + this.state.model.recipientType}
									id="modelrecipientType"
									placeholder=""
									name="recipientType"
									alt="model"
									onChange={this.handleOnChange}
									itemToString={(item) => item || ""}
									initialSelectedItem={this.state.model.recipientType || []}
									items={recipientType}
									direction="bottom"
									disabled={false}
									invalid={validations.recipientType != null}
								/>
								{validations.recipientType}
							</FormGroup>
							<FormGroup legendText="" className="bx--col-md-12 bx--col-lg-12">
								<FormLabel>HCA Level*</FormLabel>
								<MultiSelect
									id={"modelMonth"}
									key={"modelMonth_" + Math.random()}
									label={
										this.state.model.hcaLevelNames
											? this.state.model.hcaLevelNames
											: 'Choose one or more items'
									}
									multiCombo
									name="hcaLevelNames"
									alt="model"
									invalid={validations.hcaLevelNames != null && this.state.model.distributionListType =="Incidents"}
									invalidText={validations.hcaLevelNames}
									itemToString={(item) => (item ? item : '')}
									items={hcalevel}
									light={false}
									sortItems={(items) => items}
									onChange={(hcaLevelNames) =>
										this.onChangehcaLevelNames('hcaLevelNames', hcaLevelNames.selectedItems, 'model')
									}
									disabled ={this.state.model.distributionListType !="Incidents" }
									initialSelectedItems ={(hcalevel || []).filter((e) => this.state.model.hcaLevelNames !== null ? this.returnHCALevelName(e, this.state.model.hcaLevelNames) : false)}
								>
									{' '}
								</MultiSelect>
							</FormGroup>
							<FormGroup legendText="" className="bx--col-md-12 bx--col-lg-12">
								<FormLabel>Valid Since*</FormLabel>
								<DateTimePicker
									value={this.state.model.validSince}
									type="date"
									placeholder={DateFormat}
									name="validSince"
									alt="model"
									invalid={validations.validSince != null}
									onChange={this.updateState}
								/>
								{validations.validSince}
							</FormGroup>
							<FormGroup legendText="" className="bx--col-md-12 bx--col-lg-12">
								<FormLabel>Valid Until*</FormLabel>
								<DateTimePicker
									value={this.state.model.validUntil}
									type="date"
									placeholder={DateFormat}
									name="validUntil"
									alt="model"
									invalid={validations.validUntil != null}
									onChange={this.updateState}
								/>
								{validations.validUntil}
								{validations.endAfterStart && (
									<div className="srv-validation-message">
										The valid until field must be after valid since field
									</div>
								)}
								<br></br>
								<br></br>
								<br></br>
								<br></br>
								<br></br>
								<br></br>
								<br></br>
								<br></br>
								<br></br>	
							</FormGroup>
										
						</div>
					</Form>
				</ModalBody>
				<div className="bx--modal-footer">
					<Button className="button--max-width" kind="secondary" onClick={this.closeEditModal}>
						Cancel
					</Button>
					<Button className="button--max-width" kind="primary" onClick={this.insertDistributionList}>
						Save
					</Button>
				</div>
			</ComposedModal>
		);
	}

	handleChangePaging = (event) => {
		this.getPagedFilteredDistributionListIncident(event);
	};

	render() {
		this.validator.purgeFields();

		const dataTableHeaders = [
			{ key: "divisionName", header: "Business Line" },
			{ key: "recipientType", header: "Recipient Type" },
			{ key: "emailAddress", header: "Email Address" },
			{ key: "distributionListType", header: "Type" },
			{ key: "inUse", header: "In Use" },
		];

		const skeletonRowCount = this.state.rowCount > 0 && this.state.pageSize > this.state.rowCount ? this.state.rowCount : 5;

		const paginationProps = () => ({
			page: this.state.currentPage || 1,
			totalItems: this.state.rowCount || 0,
			pageSize: this.state.pageSize || 10,
			pageSizes: [10, 20, 30, 40, 50],
			onChange: this.handleChangePaging,
		});

		const confirmDelProps = () => ({
			idToDelete: this.state.idToDelete,
			isDeleting: this.state.isDeleting,
			open: this.state.isDeleteModalOpen,
			onCloseConfirm: this.onCloseConfirm,
			deleteItem: this.deleteItem,
		});
		const itemToDelete = this.state.reportDistributionListPaged.find((el) => el.id == this.state.idToDelete);

		return (
			<AppContext.Consumer>
				{() => (
					<>
						<PageBreadCrumb linkTo={"/backoffice#Global"} linkText={"BackOffice"} titleLeft={"Distribution List Incident"} />
						<div className="mainContainer">
							<ConfirmAlertCustom {...confirmDelProps()}>
								{itemToDelete != null ? (
									<DataTable
										rows={[itemToDelete]}
										headers={dataTableHeaders.filter((h) => h.key != "name")}
										useZebraStyles={true}
										size="compact"
										render={({ rows, headers, getHeaderProps, getRowProps }) => (
											<TableContainer className="bx--grid--full-width deleting-item">
												<Table>
													<TableHead>
														<TableRow>
															{headers.map((header) => (
																<TableHeader className={header.type == "bool" ? "align-center" : ""} {...getHeaderProps({ header })}>
																	{header.header}
																</TableHeader>
															))}
														</TableRow>
													</TableHead>
													<TableBody>
														{rows.map((row) => (
															<TableRow {...getRowProps({ row })}>
																{row.cells.map((cell) => (
																	<RenderDataTableCell key={cell.id} cell={cell} header={headers.find((x) => x.key === cell.info.header)} />
																))}
															</TableRow>
														))}
													</TableBody>
												</Table>
											</TableContainer>
										)}
									/>
								) : null}
							</ConfirmAlertCustom>

							{this.state.isEditModalOpen ? this.renderDetailsForm() : ""}

							<TableToolbar>
								<form className="max-width" autoComplete="off">
									<Online>
										<Search readOnly light className="search cursor-pointer hiddenSearch" id="search-1" />
									</Online>
								</form>
								<Online>
									<Button onClick={() => this.downloadFile()} className="btn-notext" iconDescription=" " renderIcon={Download16}>
										{!this.state.isExportLoading ? "" : <Loading />}
									</Button>
								</Online>
								<Online>
									<Button onClick={() => this.openAddNewModal()} renderIcon={Add16}>
										Add New
									</Button>
								</Online>
							</TableToolbar>

							{this.state.isExportLoading ? <Loading /> : null}
							<DataTable
								rows={this.state.reportDistributionListPaged}
								headers={dataTableHeaders}
								useZebraStyles={true}
								size="compact"
								render={({ rows, headers, getHeaderProps, getRowProps, getTableProps, getSelectionProps, selectedRows, getBatchActionProps }) => (
									<TableContainer className="bx--grid--full-width">
										{this.state.isLoadingEntity ? (
											<DataTableSkeleton headers={[]} rowCount={skeletonRowCount} zebra={false} compact={false} />
										) : (
											<Table>
												<TableHead>
													<TableRow>
														{headers.map((header) => (
															<TableHeader className={header.type == "bool" ? "align-center" : ""} {...getHeaderProps({ header })}>
																{header.header}
															</TableHeader>
														))}
														<TableHeader className="align-center">Actions</TableHeader>
													</TableRow>
												</TableHead>
												<TableBody>
													{rows == null || rows.length === 0 ? (
														<NoRecordsPlaceholder colSpan={headers.length} />
													) : (
														rows.map((row) => (
															<TableRow {...getRowProps({ row })}>
																{row.cells.map((cell) => (
																	<RenderDataTableCell key={cell.id} cell={cell} header={headers.find((x) => x.key === cell.info.header)} />
																))}
																<TableCell key={"action-" + row.id} className="tableActions align-center">
																	<div>
																		<Online>
																			<Button onClick={() => this.getDistributionListForEdit(row.id)} size="small" renderIcon={Edit16} iconDescription="Edit" kind="ghost" />
																			<Button onClick={() => this.confirmDelete(row.id)} size="small" renderIcon={Delete16} iconDescription="Delete" kind="ghost" />
																		</Online>
																	</div>
																</TableCell>
															</TableRow>
														))
													)}
												</TableBody>
											</Table>
										)}
									</TableContainer>
								)}
							/>

							<div className="footer-pagination">
								<Pagination {...paginationProps()} />
							</div>
						</div>
					</>
				)}
			</AppContext.Consumer>
		);
	}
}
